module.exports = __webpack_public_path__ + "img/reference-polyden.516031cf.jpg";